export const removeFirstSubstring = (str: string, substring: string) => {
  if (!str) return ''

  const index = str?.indexOf(substring)

  if (index === -1) return str

  return str.slice(0, index) + str.slice(index + substring.length)
}
